"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToBytes32 = exports.bytes32ToString = exports.capitalize = exports.normalize = exports.toWei = exports.addressShort = exports.toFixedNumber = exports.toEthN = exports.toEth = exports.fNum = exports.setDigitSeparator = void 0;
var bn_js_1 = __importDefault(require("bn.js"));
var web3_1 = __importDefault(require("web3"));
var web3_utils_1 = require("web3-utils");
var values_1 = require("../../shared/utils/values");
var DECIMALS = 4;
var digitSeparator = ",";
var setDigitSeparator = function (separator) {
    digitSeparator = separator;
};
exports.setDigitSeparator = setDigitSeparator;
var fNum = function (value, forceDecimals) {
    var _a;
    if (forceDecimals === void 0) { forceDecimals = null; }
    var withDecimals = function (d) {
        return forceDecimals === null ? d : forceDecimals;
    };
    if (bn_js_1.default.isBN(value)) {
        value = (0, exports.toEthN)(value, 18);
    }
    if (!value || isNaN(value)) {
        return 0;
    }
    if (value > 100) {
        var intPieces = String(Math.floor(value))
            .split("")
            .reverse()
            .join("")
            .match(/.{1,3}/g);
        var intStr = intPieces
            .reverse()
            .map(function (piece) { return piece.split("").reverse().join(""); })
            .join(digitSeparator);
        var decimals = value - Math.floor(value);
        var decimalsStr = (_a = decimals
            .toString()
            .split(".")[1]) === null || _a === void 0 ? void 0 : _a.substr(0, withDecimals(2));
        return [intStr, decimalsStr].filter(Boolean).join(".");
    }
    if (value > 0.01) {
        return (0, exports.toFixedNumber)(value, withDecimals(4));
    }
    if (value > 0.00000001) {
        return (0, exports.toFixedNumber)(value, withDecimals(8));
    }
    return (0, exports.toFixedNumber)(value, withDecimals(18));
};
exports.fNum = fNum;
var toEth = function (wei, digits) {
    var v = wei ? web3_1.default.utils.fromWei(wei) : "0";
    return digits ? (0, exports.toFixedNumber)(v, digits).toString() : v;
};
exports.toEth = toEth;
var toEthN = function (wei, digits) {
    var v = wei ? web3_1.default.utils.fromWei(wei) : "0";
    return digits !== undefined
        ? parseFloat((0, exports.toFixedNumber)(v, digits))
        : parseFloat(v);
};
exports.toEthN = toEthN;
/**
 * Drops unnecessary .00
 */
var toFixedNumber = function (v, digits) {
    if (digits === void 0) { digits = DECIMALS; }
    var value = typeof v === "number" ? v.toFixed(16) : v;
    var pow = (0, web3_utils_1.toBN)(Math.pow(10, 18 - digits));
    var vBN = (0, values_1.toWeiBN)(value).div(pow).mul(pow);
    return (0, web3_utils_1.fromWei)(vBN);
};
exports.toFixedNumber = toFixedNumber;
var addressShort = function (address) {
    return "".concat(address.substr(0, 6), "...").concat(address.substr(38));
};
exports.addressShort = addressShort;
function toWei(value) {
    try {
        return new bn_js_1.default(web3_1.default.utils.toWei(value));
    }
    catch (err) {
        return new bn_js_1.default("0");
    }
}
exports.toWei = toWei;
function normalize(value) {
    return value
        .trim()
        .replace(/[^\d.]/, "")
        .replace(/^0+/, "0")
        .replace(/^0([1-9])/, "$1")
        .replace(/\.(\d{0,18})\d*$/, ".$1");
}
exports.normalize = normalize;
function capitalize(v) {
    return v.charAt(0).toUpperCase() + v.slice(1);
}
exports.capitalize = capitalize;
var bytes32ToString = function (v) {
    return web3_1.default.utils.hexToAscii(v).replace(/\x00+$/g, "");
};
exports.bytes32ToString = bytes32ToString;
var stringToBytes32 = function (v) {
    return web3_1.default.utils.asciiToHex(v).padEnd(66, "0");
};
exports.stringToBytes32 = stringToBytes32;
